import * as React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Heading from '~components/Heading';
import List from '~components/List';
import Text from '~components/Text';
import FullscreenVideo from '~components/FullscreenVideo';

import { fullWidthImage } from '~theme';

import missionVisionWebm from '../videos/mission-vision-values.webm';
import missionVisionMp4 from '../videos/mission-vision-values.mp4';

const MissionPage: React.FC = () => (
  <Layout>
    <SEO title="Vision, Mission & Core Beliefs" desc="" />
    <FullscreenVideo
      src={{
        webm: missionVisionWebm,
        mp4: missionVisionMp4
      }}
    >
      <div tw="bg-[#41020A] text-white bg-opacity-95 pt-12">
        <div tw="grid lg:(grid-cols-2 gap-12)">
          <div tw="flex flex-col items-center justify-center lg:(col-start-2 row-start-1)">
            <div tw="px-6 lg:px-12">
              <Heading tw="leading-tight my-0" level="h1">
                Vision, Mission &amp; Core Beliefs
              </Heading>
            </div>
          </div>
          <div tw="lg:(col-start-1 row-start-1)">
            <StaticImage src="../images/arms-crossed-red-hero.png" alt="" />
          </div>
        </div>
      </div>
    </FullscreenVideo>
    <div tw="bg-[#41020A] py-2 md:py-12 text-white">
      <div tw="container">
        <Heading level="h2">Vision</Heading>
        <p tw="text-base md:text-xl my-4">
        High quality care delivered with great heart – for every person, every time, everywhere.
        </p>
        <Heading level="h2">Mission</Heading>
        <p tw="text-base md:text-xl my-4">
        Creating possibilities for more independence, championing the needs of our clients and families and delivering high quality, integrated care.
        </p>
        <Heading level="h2">Core Beliefs</Heading>
        <List tw="text-base md:text-xl my-1">
          <li><b>Client-driven</b> because what matters most to clients and families is what counts</li>
          <li><b>Spectacular</b> and continuously focused on quality improvement and safety</li>
          <li><b>Integrated and collaborative</b> to unearth innovative answers to complex challenges</li>
          <li><b>Inclusive and committed</b> to serving the most vulnerable in our communities</li>
          <li><b>Inspired and creative</b>, delivered by a skilled team that has tremendous heart</li>
        </List>
        <Text tw="font-bold text-base md:text-2xl">
          As a charitable not-for-profit organization led by a volunteer Board of Directors, VHA is
          committed to:
        </Text>
        <List tw="text-base md:text-xl my-1">
          <li>Valuing and supporting our staff and care providers</li>
          <li>Fiscal responsibility</li>
          <li>Driving positive change in community support and home health care</li>
          <li>Ethical practices in all our operations</li>
        </List>
      </div>
      <StaticImage src="../images/people-distancing.jpg" alt="" css={fullWidthImage} />
      <div tw="container">
        <div tw="lg:(grid gap-12 grid-cols-2)">
          <div>
            <Heading level="h2">Board Members</Heading>
            <List tw="m-0 list-none text-base md:text-xl my-1">
              <li>Karen N. Singh, Board Chair </li>
              <li>Ian Brunskill </li>
              <li>Sheree Davis </li>
              <li>Eitan Dehtiar </li>
              <li>Susan Grundy </li>
              <li>Michael Kenigsberg </li>
              <li>Adrianne Largo </li>
              <li>Joseph Mayer </li>
              <li>Paul Moroney </li>
              <li>Ella Seitz </li>
              <li>Cindy Veinot </li>
              <li>Karen Waite </li>
              <li>Catherine Wiley</li>
            </List>
          </div>
          <div>
            <Heading level="h2">Client &amp; Carer Advisory Council Members</Heading>
            <List tw="m-0 list-none text-base md:text-xl my-1">
              <li>Amr Elimam, Co-Chair </li>
              <li>David Shaul </li>
              <li>Sandra Shaul </li>
              <li>Michael Vince </li>
              <li>Margot Algie </li>
              <li>Vince Aliberti </li>
              <li>Laura Williams </li>
              <li>Patrick Walters </li>
              <li>Debby Vigoda</li>
              <li>Ralda Singleton</li>
              <li>Paul Morse</li>
            </List>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default MissionPage;
